/**
 * AJAX qty updates on cart page — serialized to avoid stale line-key races.
 */
(function () {
  var pendingByVariant = new Map();
  var pumpRunning = false;

  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  }

  function isFeeItem(item) {
    if (window.LbRemoveFee && typeof window.LbRemoveFee.isFeeItem === "function") {
      return window.LbRemoveFee.isFeeItem(item);
    }
    return item && item.product_handle === "lb-order-margin";
  }

  function formatMoneyCents(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(
        cents,
        window.Shopify.money_format || "${{amount}}"
      );
    }
    return "$" + (Number(cents) / 100).toFixed(2);
  }

  function renderLinePricing(qty, item) {
    var html = "";
    var lineTotal = item.final_line_price || 0;
    html +=
      '<p class="lb-cart-line__price">' +
      '<span class="lb-cart-line__price-label">Line total</span> <strong>' +
      formatMoneyCents(lineTotal) +
      "</strong></p>";
    return html;
  }

  function findLineForItem(item) {
    var form = document.getElementById("cart-form");
    if (!form || !item) return null;
    return (
      form.querySelector('.lb-cart-line[data-variant-id="' + item.variant_id + '"]') ||
      form.querySelector('.lb-cart-line[data-line-key="' + item.key + '"]')
    );
  }

  function setLineKey(line, key) {
    if (!line || !key) return;
    line.setAttribute("data-line-key", key);
    line.querySelectorAll("[data-line-key]").forEach(function (el) {
      el.setAttribute("data-line-key", key);
    });
    var removeBtn = line.querySelector("[data-remove-key]");
    if (removeBtn) removeBtn.setAttribute("data-remove-key", key);
  }

  function syncLinesFromCart(cart) {
    var form = document.getElementById("cart-form");
    if (!form || !cart) return;

    var seenVariants = {};

    (cart.items || []).forEach(function (item) {
      if (isFeeItem(item)) return;
      seenVariants[String(item.variant_id)] = true;
      var line = findLineForItem(item);
      if (!line) return;
      setLineKey(line, item.key);
      var input = line.querySelector("input[data-line-key]");
      if (input) input.value = String(item.quantity);
      syncQtyButtons(line);
    });

    form.querySelectorAll(".lb-cart-line").forEach(function (line) {
      var variantId = line.getAttribute("data-variant-id");
      if (variantId && !seenVariants[variantId]) line.remove();
    });
  }

  function updateCartLinePricing(cart) {
    (cart.items || []).forEach(function (item) {
      if (isFeeItem(item)) return;
      var line = findLineForItem(item);
      if (!line) return;
      var pricing = line.querySelector(".lb-cart-line__pricing");
      if (!pricing) return;

      var qty = item.quantity || 1;
      pricing.innerHTML = renderLinePricing(qty, item);
    });
  }

  function setCartBusy(busy) {
    var form = document.getElementById("cart-form");
    if (!form) return;
    form.classList.toggle("is-cart-updating", busy);
    form.querySelectorAll("[data-qty-delta], [data-remove-key], input[data-line-key]").forEach(
      function (el) {
        el.disabled = busy;
      }
    );
    if (!busy) {
      form.querySelectorAll(".lb-cart-line").forEach(syncQtyButtons);
    }
  }

  function showToast(msg, isError) {
    var toast = document.getElementById("lb-cart-toast");
    if (!toast) return;
    toast.textContent = msg;
    toast.className =
      "lb-cart-toast" + (isError ? " lb-cart-toast--error" : "") + " is-visible";
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function () {
      toast.classList.remove("is-visible");
    }, 4000);
  }

  function fetchCart() {
    return fetch(routesRoot() + "cart.js", {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    }).then(function (r) {
      return r.json();
    });
  }

  function postChange(key, qty) {
    return fetch(routesRoot() + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify({ id: key, quantity: qty }),
    }).then(function (r) {
      return r.json();
    });
  }

  function finishCart(cart) {
    if (!cart || cart.status) {
      return Promise.reject(
        new Error((cart && (cart.description || cart.message)) || "Update failed")
      );
    }

    if (cart.item_count === 0) {
      window.location.reload();
      return Promise.resolve(cart);
    }

    var chain = Promise.resolve(cart);
    if (window.LbRemoveFee && typeof window.LbRemoveFee.removeFeeLines === "function") {
      chain = chain.then(function (c) {
        return window.LbRemoveFee.removeFeeLines(c);
      });
    }

    return chain.then(function (finalCart) {
      if (!finalCart || finalCart.status) {
        return Promise.reject(
          new Error(
            (finalCart && (finalCart.description || finalCart.message)) || "Update failed"
          )
        );
      }
      syncLinesFromCart(finalCart);
      updateCartLinePricing(finalCart);
      if (window.LbUkUsShipping && typeof window.LbUkUsShipping.refreshCart === "function") {
        window.LbUkUsShipping.refreshCart(finalCart);
      } else if (
        window.LbCartSummary &&
        typeof window.LbCartSummary.updateCartSummary === "function"
      ) {
        window.LbCartSummary.updateCartSummary(finalCart);
      }
      document.dispatchEvent(
        new CustomEvent("lb:cart-updated", {
          detail: { cart: finalCart, _lbMarginSync: true },
        })
      );
      return finalCart;
    });
  }

  function recoverCart(err) {
    showToast(err && err.message ? err.message : "Could not update cart", true);
    return fetchCart().then(function (cart) {
      if (!cart || !cart.items) return;
      syncLinesFromCart(cart);
      updateCartLinePricing(cart);
      if (window.LbCartSummary && typeof window.LbCartSummary.updateCartSummary === "function") {
        window.LbCartSummary.updateCartSummary(cart);
      }
      if (window.LbUkUsShipping && typeof window.LbUkUsShipping.refreshCart === "function") {
        window.LbUkUsShipping.refreshCart(cart);
      }
    });
  }

  function applyLineQty(line, qty) {
    if (!line) return Promise.resolve();
    if (qty > 0) qty = Math.min(qty, maxQtyPerItem());
    line.classList.add("is-updating");
    var key = line.getAttribute("data-line-key");
    return postChange(key, qty)
      .then(finishCart)
      .catch(recoverCart)
      .finally(function () {
        line.classList.remove("is-updating");
      });
  }

  function pumpQueue() {
    if (pumpRunning) return;
    pumpRunning = true;
    setCartBusy(true);

    function next() {
      if (pendingByVariant.size === 0) {
        pumpRunning = false;
        setCartBusy(false);
        return Promise.resolve();
      }

      var entry = pendingByVariant.entries().next().value;
      pendingByVariant.delete(entry[0]);
      var job = entry[1];
      return applyLineQty(job.line, job.qty).then(next);
    }

    next().catch(function () {
      pumpRunning = false;
      setCartBusy(false);
    });
  }

  function maxQtyPerItem() {
    if (window.LbQtyLimit && typeof window.LbQtyLimit.max === "function") {
      return window.LbQtyLimit.max();
    }
    var n = Number(window.LB_MAX_QTY_PER_ITEM);
    return Number.isFinite(n) && n > 0 ? Math.floor(n) : 24;
  }

  function limitMessage() {
    if (window.LbQtyLimit && typeof window.LbQtyLimit.message === "function") {
      return window.LbQtyLimit.message();
    }
    return "You can buy up to " + maxQtyPerItem() + " of each item.";
  }

  function scheduleLineQty(line, qty) {
    if (!line) return;
    var variantId = line.getAttribute("data-variant-id");
    if (!variantId) return;

    var requested = parseInt(qty, 10);
    if (!Number.isFinite(requested)) requested = 0;
    var max = maxQtyPerItem();
    var safeQty = Math.max(0, requested);
    if (safeQty > max) {
      safeQty = max;
      showToast(limitMessage(), true);
    }
    pendingByVariant.set(variantId, { line: line, qty: safeQty });

    var input = line.querySelector("input[data-line-key]");
    if (input) input.value = String(safeQty);
    syncQtyButtons(line);

    pumpQueue();
  }

  function syncQtyButtons(line) {
    if (!line) return;
    var input = line.querySelector("input[data-line-key]");
    var minus = line.querySelector(".lb-cart-qty__btn--minus");
    var plus = line.querySelector(".lb-cart-qty__btn--plus");
    if (!input) return;
    var qty = parseInt(input.value, 10) || 0;
    if (minus) minus.disabled = qty <= 1;
    if (plus) plus.disabled = qty >= maxQtyPerItem();
  }

  function initCartPage() {
    var form = document.getElementById("cart-form");
    if (!form) return;

    form.querySelectorAll(".lb-cart-line").forEach(syncQtyButtons);

    form.querySelectorAll("input[data-line-key]").forEach(function (input) {
      input.addEventListener("change", function () {
        var line = input.closest(".lb-cart-line");
        scheduleLineQty(line, input.value);
      });
    });

    form.querySelectorAll("[data-qty-delta]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var line = btn.closest(".lb-cart-line");
        var input = line ? line.querySelector("input[data-line-key]") : null;
        if (!input) return;
        var delta = parseInt(btn.getAttribute("data-qty-delta"), 10) || 0;
        var current = parseInt(input.value, 10) || 0;
        if (delta > 0 && current >= maxQtyPerItem()) {
          showToast(limitMessage(), true);
          return;
        }
        var next = Math.max(0, current + delta);
        scheduleLineQty(line, next);
      });
    });

    form.querySelectorAll("button[data-remove-key]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var line = btn.closest(".lb-cart-line");
        scheduleLineQty(line, 0);
      });
    });
  }

  function refreshCartLinePricingOnLoad() {
    if (!document.getElementById("cart-form")) return;
    fetchCart()
      .then(function (cart) {
        if (!cart || !cart.items) return cart;
        var over =
          window.LbQtyLimit && typeof window.LbQtyLimit.linesOverLimit === "function"
            ? window.LbQtyLimit.linesOverLimit(cart)
            : [];
        if (!over.length) return cart;
        showToast(limitMessage(), true);
        return over.reduce(function (chain, line) {
          return chain.then(function () {
            return postChange(line.key, line.quantity);
          });
        }, Promise.resolve());
      })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        syncLinesFromCart(cart);
        if (window.LbUkUsShipping && typeof window.LbUkUsShipping.refreshCart === "function") {
          window.LbUkUsShipping.refreshCart(cart);
          return;
        }
        updateCartLinePricing(cart);
        if (window.LbCartSummary) {
          window.LbCartSummary.updateCartSummary(cart);
        }
      })
      .catch(function () {});
  }

  document.addEventListener("DOMContentLoaded", function () {
    initCartPage();
    refreshCartLinePricingOnLoad();
  });
})();
